var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24 9.081a.96.96 0 0 0-1.358 0l-2.341 2.343-.902-.902A.96.96 0 0 0 0 11.2v4.054c0 .425.323.746.72.746H4.8a.96.96 0 0 0 .679-1.639l-.902-.902 2.342-2.342a.96.96 0 0 0 0-1.358l-.679-.678zM15.256 0H11.19a.961.961 0 0 0-.676 1.639l.898.901L9.08 4.882a.963.963 0 0 0 0 1.358l.676.679a.954.954 0 0 0 1.353 0l2.333-2.342.899.901a.957.957 0 0 0 1.042.209.956.956 0 0 0 .617-.914V.693c0-.37-.32-.693-.744-.693z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandEvent);
export default __webpack_public_path__ + "static/media/expand-event.36fe521638e54b8158af0a91011c4194.svg";
export { ForwardRef as ReactComponent };